<script setup>
import { FormInput } from "@Components/Form";
import { useStore } from "@/Stores/requiredSettings";
import { useForm } from "@/form";
import { useI18n } from "vue-i18n";
import { PixabayIcon } from "@Icons/index";
import FormBase from "./FormBase.vue";

const props = defineProps({
    settings: Object,
});

const { t: __ } = useI18n();
const store = useStore();

const form = useForm({
    api_key: props.settings?.api_key,
});

const submit = () => {
    if (form.processing) return;
    form.post("settings_api_update_pixabay").then(() => {
        store.refresh();
    });
};
</script>

<template>
    <FormBase @submit="submit" :form="form" :icon="PixabayIcon" optional>
        <template #title>
            {{ __("Pixabay") }}
        </template>
        <template #description>
            <span class="block"
                >{{ __("Pixabay est une banque d'images totalement gratuite qui s'appuie sur plus de 1,7 million d'images partagées par sa communauté.") }}
            </span>
        </template>
        <template #form>
            <FormInput v-model="form.api_key" :label="__('Clé API')" :errors="form.errors.get('api_key')" sensitive>
                <template #hint>
                    <a href="https://pixabay.com/api/docs" target="_blank" class="font-bold text-gray-900 dark:text-white hover:underline">{{
                        __("Obtenir la clé API")
                    }}</a>
                </template>
            </FormInput>
        </template>
    </FormBase>
</template>
